import { type AppConfig } from '#apps/client-web/app/config/app';

export type SplashPageViewModel = ReturnType<typeof useSplashPageViewModel>;

export const useSplashPageViewModel = ({
  appConfig,
}: {
  appConfig: AppConfig;
}) => {
  return {
    // add prefix 'v' to version
    version: `v${appConfig.version}`,
  };
};
